import * as Icons from "lucide-react";

export default function Icon({ name, ...props }) {
  const LucideIcon = Icons[name] || Icons.Circle;
  return <LucideIcon {...props} />;
}
